/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Timer_viewer = {
    readonly timerStartDate: string | null;
    readonly timerEndDate: string | null;
    readonly timerTask: {
        readonly id: string;
    } | null;
    readonly " $refType": "Timer_viewer";
};
export type Timer_viewer$data = Timer_viewer;
export type Timer_viewer$key = {
    readonly " $data"?: Timer_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Timer_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Timer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerEndDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '78b1b516352c9a99a45b8e0b76b62369';
export default node;
